import { Button } from '@civilgrid/ui/components';
import { useState } from 'react';
import { refreshTiles as apiRefreshTiles } from '~/api/internal';
import { Notify } from '~/components2/Notify';
import { MajorHeading } from '../common/Heading';

export default function RefreshTiles() {
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setIsLoading(true);

      const res = await apiRefreshTiles();

      if (!res.success) {
        throw 'Failed';
      }

      Notify.info({
        message: `Tiles refresh started - ${res.id}`,
      });
    } catch {
      Notify.error({
        message: 'An error occurred while attempting to refreshing tiles. Check logs for details',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <MajorHeading tooltip="Refresh tile-server with latest tiles from s3">Refresh tiles</MajorHeading>
      <Button onClick={onSubmit} loading={isLoading} disabled={isLoading}>
        Refresh
      </Button>
    </div>
  );
}
